module.exports = __webpack_public_path__ + "media/images/help/new-submission-submit-1c988a5c92ae7a3edc3cf3859fc8e1cf.png";